import React from 'react';
import Seo from '../components/Seo';

const NotFoundPage = () => {
  return (
    <>
      <Seo title="Page Not Found | Prime Movers" description="The page you requested could not be found." canonical="https://askprimemovers.ca/404" h1="Page Not Found" />
      <main className="max-w-4xl mx-auto px-4 py-20 text-center">
        <div className="rounded-3xl bg-white border border-gray-200 shadow-sm p-10">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-[#3f9422]">404</p>
          <h1 className="text-4xl md:text-6xl font-black text-gray-900 mt-6">This page could not be found.</h1>
          <p className="mt-4 text-lg text-gray-700">The page you are looking for may have moved or no longer exists.</p>
          <div className="mt-8 flex justify-center gap-4 flex-wrap">
            <a href="/" className="rounded-full bg-[#3f9422] px-6 py-3 text-base font-semibold text-white hover:bg-[#2e7a1b]">Back Home</a>
            <a href="/contact-us" className="rounded-full border border-[#3f9422] px-6 py-3 text-base font-semibold text-[#3f9422] hover:bg-green-50">Contact Us</a>
          </div>
        </div>
      </main>
    </>
  );
};

export default NotFoundPage;
